<script>
export default {
  components: {},
  props: {
    prospect: {
      type: Object,
      required: true,
      default: () => {},
    },
    campaign: {
      type: Object,
      required: true,
      default: () => {},
    },
    campaignNum: {
      type: Number,
      required: false,
      default: null,
    },
    isConverted: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div
    :class="[
      'circle',
      { completed: campaign.order <= prospect.status || prospect.is_converted },
    ]"
    v-if="prospect"
  >
    <img
      src="@assets/images/emoji-congrats.svg"
      v-if="isConverted && !campaignNum"
    />
    <span v-else>{{ campaignNum }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.circle {
  align-items: center;
  border: 1px solid $color-primary;
  border-radius: $border-button-radius-round;
  color: $color-primary;
  display: flex;
  font-size: 1.4rem;
  font-weight: 900;
  height: 2.4rem;
  justify-content: center;
  letter-spacing: -0.257143px;
  line-height: 1.4rem;
  width: 2.4rem;

  &.completed {
    background-color: $color-primary;
    color: white;
  }
}
</style>
